import React from 'react';
import SectionTitle from '../SectionTitle';
import Linkify from 'linkify-react';

// the following imports contents to populate the textual components
import '../Main.css';
import './Activities.css';
import {activities} from '../../data/activities/activities';

// This lays out the main page, including the header (navbar), footer, and everything in between
// All contents are in terms of components, with Main as the mother of components 

function Activities(props) {

    // Prepare headings for bilingual 
    // set language icon, menu items and texts based on the language state from props.language
    var activitiesHeading = '';
    if (props.language === 'en') {
        activitiesHeading = 'Guide to Activities';
    } else if (props.language === 'jp') {
        activitiesHeading = 'アクティビティガイド';
    } else if (props.language === 'ch1') {
        activitiesHeading = '活动指南';
    } else if (props.language === 'ch2') {
        activitiesHeading = '活動指南';
    } else {}

    // scroll to the top of the page when coming from another route
    window.scroll(0,0);
    
    var seasonName = [], seasonCaption = [], activitiesContentWinter, activitiesContentGreen;
    /* swiper add: This block code processes the Room Types Section (roomtypes.js), prepares PhotoFrameMany components */
    for (let season_id = 0; season_id < activities.length; season_id++) {

        const activitiesContent = activities[season_id].activities.map(activity => {

            console.log("season name and caption = ", seasonName, seasonCaption);
            var heading = '', text ='';
            
            if (props.language === 'en' ) { 
                    seasonName[season_id] = activities[season_id].name;
                    seasonCaption[season_id] = activities[season_id].caption;
                    heading = activity.name; 
                    text = activity.text; 
                }
            else if (props.language === 'jp' ) { 
                    seasonName[season_id] = activities[season_id].nameJ;
                    seasonCaption[season_id] = activities[season_id].captionJ;
                    heading = activity.nameJ; 
                    text = activity.textJ;
                }
            else if (props.language === 'ch1' ) { 
                seasonName[season_id] = activities[season_id].nameCh1;
                seasonCaption[season_id] = activities[season_id].captionCh1;
                heading = activity.nameCh1; 
                text = activity.textCh1;
            }
            else if (props.language === 'ch2'  ) { 
                seasonName[season_id] = activities[season_id].nameCh2;
                seasonCaption[season_id] = activities[season_id].captionCh2;
                heading = activity.nameCh2; 
                text = activity.textCh2;
            }
            else {}

            const options ={}; 
            return (
                <div key={activity.id} className='activitiesSection'>
                    {/* The floowing block renders the activities list with images */}
                    <div className='activitiesSectionImageAndText'>
                        <img src={process.env.PUBLIC_URL+activity.image} className='activitiesSectionImage' alt={activity.name}/>
                        <div className='activitiesSectionText'>
                            <h4>{heading}</h4>
                            <div className='activityParagraph'>
                                {/* <p>{pText}</p>  */}
                                <Linkify as="p" options={options}>
                                    {text}
                                </Linkify>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })

        if (season_id === 0) activitiesContentWinter = activitiesContent;
        else activitiesContentGreen = activitiesContent;
    }

    return (
        <div className='activitiesContainer'>
        { /*<div className='background'>
            <Header /> */ }

            <SectionTitle ids='activities' title={activitiesHeading} />

            {/* This block is rendering of activities for winter season */}
            <div className='activitiesSeason'>
                <div className='seasonTitle'>{seasonName[0]}</div>
                <div className='seasonCaption'>{seasonCaption[0]}</div>
            </div>
            {activitiesContentWinter}

            <div className='sectionEnd'>{}</div>
            
            {/* This block is rendering of activities for green season */}
            <div className='activitiesSeason'>
                <div className='seasonTitle'>{seasonName[1]}</div>
                <div className='seasonCaption'>{seasonCaption[1]}</div>
            </div>
            {activitiesContentGreen}

            <div className='sectionEnd'>{}</div>

        </div>
    )
}

export default Activities;